import React from 'react';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { ProductVariant } from '../../../../models/product.variant.model';
import { Service } from '../../../../models/service.model';
import { formatMoney, formatTaxRate } from '../../../../scripts/format.value.script';
import { discountDescription, discountType } from '../../../../libraries/discount.library';

export interface AppInventoryViewDetailProps {
  inventory: string,
  record: any | Service | ProductVariant
};

const AppInventoryViewDetail: React.FunctionComponent<AppInventoryViewDetailProps> = ({inventory, record}) => {
  const {companyForUser} = UseOutletContextInventory()
  const {lang} = StateLanguage()

  return (
    <>
      { companyForUser &&
        <table className="table fw-bold gs-0 gy-2 m-0">
          <tbody>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.description}:</td>
              { inventory === "service" &&
                <td className="min-w-200px">{record.description}</td>
              }
              { inventory === "product" &&
                <td className="min-w-200px">{record.description_short}</td>
              }
            </tr>
            { inventory === "product" &&
              <tr>
                <td className="w-150px text-muted fs-7">{lang.labels.comment}:</td>
                <td className="min-w-200px">{(record.description_long ?? '').length > 0 ? record.description_long : lang.labels.none}</td>
              </tr>
            }
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.code}:</td>
              <td className="min-w-200px text-capitalize">{(record.code ?? '').length > 0 ? record.code : lang.labels.none}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.sku}:</td>
              <td className="min-w-200px text-capitalize">{(record.sku ?? '').length > 0 ? record.sku : lang.labels.none}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.codebar}:</td>
              <td className="min-w-200px text-capitalize">{(record.codebar ?? '').length > 0 ? record.codebar : lang.labels.none}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.unit}:</td>
              <td className="min-w-200px text-capitalize">{record.unit?.name ?? record.unit?.id ?? lang.labels.none}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.priceSale}:</td>
              <td className="min-w-200px text-nowrap">{companyForUser.currency?.code} {formatMoney(record.price_sale?.amount ?? 0)}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.pricePurchase}:</td>
              <td className="min-w-200px text-nowrap">{companyForUser.currency?.code} {formatMoney(record.price_purchase?.amount ?? 0)}</td>
            </tr>
            { (record.features ?? []).map (( (item: any, index: number) => { return (
              <tr key={index}>
                <td className="w-150px text-muted fs-7">{item.name}:</td>
                <td className="min-w-200px text-nowrap">{item.value}</td>
              </tr>
            )}))}
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.taxSale}:</td>
              <td className="min-w-200px d-flex align-items-center text-nowrap">
                {formatTaxRate(record.price_sale?.tax_rate ?? 0)} %
                <div className="fw-bolder fs-9 ms-2">
                    {"["}{record.price_sale?.tax_code ?? ''}{"]"}
                  </div>
              </td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.taxPurchase}:</td>
              <td className="min-w-200px d-flex align-items-center text-nowrap">
                {formatTaxRate(record.price_purchase?.tax_rate ?? 0)} %
                <div className="fw-bolder fs-9 ms-2">
                    {"["}{record.price_purchase?.tax_code ?? ''}{"]"}
                  </div>
              </td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.discount}:</td>
              <td className="min-w-200px text-capitalize text-nowrap">
                {discountDescription(lang, companyForUser.currency, record.discount ?? {type: 'none', value: 0, quantity: 0})}
                { record.discount?.type !== "none" && record.discount &&
                  <span className="badge badge-light fs-9 text-uppercase ms-2">{discountType(lang, record.discount)}</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      }
    </>
  )
};

export default AppInventoryViewDetail;
